/**
 * Labstep
 */

import type {
  APICreateAction,
  APIUpdateAction,
} from 'labstep-web/models';
import { ProtocolCondition } from 'labstep-web/models/protocol-condition.model';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import type { ResourceItem } from 'labstep-web/models/resource-item.model';

export const getOnChange =
  (
    protocolValueTemplate: ProtocolValue,
    createProtocolCondition: APICreateAction<'protocol_condition'>,
    createProtocolValue: APICreateAction<'protocol_value'>,
    updateProtocolValue: APIUpdateAction<'protocol_value'>,
    protocolValuesOrConditions: (ProtocolValue | ProtocolCondition)[],
  ) =>
  (resourceItems: ResourceItem[] | null): void => {
    if (!resourceItems) {
      return;
    }
    const createBody = (
      values: ProtocolValue[],
    ): { resource_item_id: string; guid: string }[] =>
      values.map((v, i) => ({
        resource_item_id: resourceItems[i].guid,
        guid: v.guid,
      }));

    const updateProtocolValuesBody = protocolValuesOrConditions
      .map((v, i) => {
        if (v instanceof ProtocolValue) {
          return {
            resource_item_id: resourceItems[i].guid,
            id: v.guid,
          };
        }
      })
      .filter((v) => v !== undefined);

    const createProtocolValuesBody = protocolValuesOrConditions
      .map((v, i) => {
        if (v instanceof ProtocolCondition) {
          return {
            ...(v.experiment && {
              experiment_id: v.experiment.guid,
            }),
            ...(protocolValueTemplate.protocol && {
              protocol_id: protocolValueTemplate.protocol.guid,
            }),
            ...(v.experiment && {
              experiment_id: v.experiment.guid,
            }),
            ...(v.protocol && {
              protocol_id: v.protocol.guid,
            }),
            resource_item_id: resourceItems[i].guid,
            variable_template_guid: protocolValueTemplate.guid,
            protocol_condition_id: v.guid,
            ...(protocolValueTemplate.unit && {
              unit: protocolValueTemplate.unit,
            }),
          };
        }
      })
      .filter((v) => v !== undefined);

    if (
      updateProtocolValuesBody.length > 0 &&
      protocolValueTemplate.is_input
    ) {
      updateProtocolValue(updateProtocolValuesBody as any);
    }
    if (
      createProtocolValuesBody.length > 0 &&
      protocolValueTemplate.is_input
    ) {
      createProtocolValue(createProtocolValuesBody as any);
    }
    if (protocolValuesOrConditions.length > 1) {
      return;
    }

    const protocol = protocolValueTemplate.parent;
    createProtocolCondition(
      new Array(resourceItems.length).fill({
        [`${protocol.entityName}_id`]: protocol.guid,
      }) as any,
      {
        onSuccess: ({ response }) => {
          createProtocolValue(
            createBody(
              (
                Object.values(
                  response!.entities.protocol_value,
                ) as ProtocolValue[]
              ).filter(
                (v) =>
                  v.variable_template_guid ===
                  protocolValueTemplate.guid,
              ),
            ) as any,
          );
        },
      },
    );
  };
